<template>
  <div :class="{'container-manage': !isMenuMiniSize, 'container-manage-thin-menu': isMenuMiniSize}">
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Media</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">画像 / 動画 管理画面</p>
      </div>
      <div class="tabs is-toggle">
        <ul>
          <li :class="{'is-active': mediaType === 'image'}">
            <a style="width: 128px;" @click="changeType('image')"><span>画像倉庫</span></a>
          </li>
          <li :class="{'is-active': mediaType === 'movie'}">
            <a style="width: 128px;" @click="changeType('movie')"><span>動画倉庫</span></a>
          </li>
        </ul>
      </div>
    </div>
    <ImagePool @changeCreateMedia="changeCreateMedia" v-if="mediaType=='image'"/>
    <MoviePool @changeCreateMedia="changeCreateMedia" v-if="mediaType=='movie'"/>
    <ModalCreateMedia
      :isShowModal="isModalCreateMedia"
      :type="type"
      :images="images"
      :videos="videos"
      @cancel="changeCreateMedia"
      @createMediaPool="createMediaPool"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalEditMedia :PCTRLLOG="CTRLLOG"/>
  </div>
</template>

<script>
import { mapState }     from 'vuex'
import ImagePool        from '@/views/DashBoard/MediaPool/ImagePool'
import MoviePool        from '@/views/DashBoard/MediaPool/MoviePool'
import ModalCreateMedia from '@/components/ui/ModalCreateMedia'
import ModalEditMedia   from '@/components/ui/ModalEditMedia'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    ImagePool,
    MoviePool,
    ModalCreateMedia,
    ModalEditMedia
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('mediapool',['images', 'videos', 'selectModalTarget']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  data () {
    return {
      COMPONENT_NAME: 'MediaPool',
      mediaType: 'image',
      isModalCreateMedia: false,
      type: null
    }
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  watch: {
  },
  methods: {
    changeType (type) {
      this.mediaType = type
    },
    changeCreateMedia (data) {
      this.isModalCreateMedia = data.flg
      this.type = data.type
    },
    createMediaPool (data) {
      if (data.type === 'image') {
        let createFile = new FormData()
        createFile.append('name', data.data.file.name)
        createFile.append('tags', data.data.tags)
        createFile.append('image_data', data.data.file)
        this.$store.dispatch('mediapool/saveImage', createFile)
      } else {
        let createFile = new FormData()
        createFile.append('name', data.data.file.name)
        createFile.append('tags', data.data.tags)
        createFile.append('video_data', data.data.file)
        this.$store.dispatch('mediapool/saveVideo', createFile)
      }
    }
  }
}
</script>

<style scoped>
.container-manage {
  height: 100vh;
  width: calc(100% - 205px);
}
.container-manage-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-box {
  width: 100%;
  padding: 0;
}
.export-box {
  height: calc(100vh - 130px);
  width: 100%;
}
.export-list {
  margin: 20px;
  margin-right: 5px;
  margin-left:  10px;
  height: calc(100% - 40px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
}
.export-list-header {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.export-list-body {
  border-radius: 10px;
  width: 190px;
  text-align: center;
  color: black;
  font-size: 16px;
  margin: 5px;
  margin-bottom: 0;
  padding: 10px;
  background: white;
  min-height: 44px;
}
.export-footer {
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-box {
  margin: 20px;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* padding: 20px; */
  width: 210px;
  height: 40px;
}
.date-box {
  width: 40%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between
}
.resume-btn {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  font-size: 16px;
}

.wrapper-cover-img {
  position: relative;
}

.input-box {
  text-align: left;
  width: 100%;
  display: flex;
  border-bottom: solid thin #ccc !important;
  border-right: solid thin #ccc !important;
  border-left: solid thin #ccc !important;
}
.input-label {
  width: 30%;
  border-right: solid thin #ccc !important;
  background: rgba(250, 230, 230) !important;
  padding: 8px !important;
}
.input-modal {
  width: calc(100% - 30%);
  height: 40px;
  color: #222 !important;
  font-size: 16px !important;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

.table-box {
  width: 100%;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.input-table {
  height: 40px;
  color: #222 !important;
  font-size: 16px;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/MediaPool/MediaPool.vue